import React from 'react';

const AboutPage = () => (
  <div className="about-page">
    About
  </div>
)

export default AboutPage;